<!--
 * @FileDescription: 批量生成账单信息对话框
 * @Author: 陈文景
 * @Date: 2022-12-27 13:48:03
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="生成账单信息" :visible.sync="visible" width="1024px" :before-close="close">
    <div class="top">账单明细</div>

    <el-table v-loading="loading" :data="bills" size="medium" border row-key="id" :style="{ width: `${tableWidth}%` }" :height="`${tableHeight}px`">
      <el-table-column prop="kkOrderId" label="订单号" />
      <el-table-column prop="packId" label="包裹号">
        <template v-slot="{ row }">
          {{ defaultTips(row.packId) }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="应收款">
        <template v-slot="{ row }">
          {{ amount(row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="发货时间">
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.deliveryDate)) }}
        </template>
      </el-table-column>
      <el-table-column label="包裹状态">
        <template v-slot="{ row }">
          {{ fulfillmentStatus(row.fulfillmentStatus) }}
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <span>
        <span>应收款: </span>
        +US$ <el-input-number v-model="from.amount" size="small" controls-position="right" :precision="2" :min="0" :max="999999999" />
      </span>
      <el-button type="primary" size="medium" @click="save">确认生成</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'

export default {
  data() {
    return {
      visible: false,

      formatTimeStamp,

      tableWidth: 100,
      tableHeight: 380,

      from: {
        ids: [],
        amount: undefined // 应收款
      },

      loading: false,
      bills: []
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `+US$${value}` : '-'
      }
    },
    fulfillmentStatus() {
      return (value) => {
        switch (value) {
          case 'waiting_to_ship':
            return '待发货'
          case 'shipped':
            return '已发货'
          case 'partial_shipped':
            return '部分发货'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 生成账单
     */
    async generateBills() {
      let { code, message } = await API.generateBills({ ...this.from })
      if (code === 10000) {
        this.close()
        this.$emit('update')
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    show(payload) {
      this.bills = payload
      this.from.ids = payload.map((item) => item.id)
      this.from.amount = payload.reduce((previous, item) => {
        if (item) {
          previous += item.amount
        }
        return previous
      }, 0)
      this.visible = true
    },

    save() {
      this.generateBills()
    },

    close() {
      this.clear()
      this.visible = false
    },

    clear() {
      this.from = {
        ids: [],
        amount: undefined
      }
      this.bills = []
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  line-height: 32px;
  padding-left: 8px;
  margin-bottom: 15px;
  border-left: 3px solid #99c41c;
}

.dialog-footer {
  .el-button {
    margin-left: 15px;
  }
}
</style>
